jQuery(function () {
  const countDownWrapper = document.getElementById("simplified-countdown");
  if (countDownWrapper) {
    const form = document.getElementById("giveaway-form");
    const formHeading = form.previousSibling.previousElementSibling;
    const countDownDate = new Date(countDownWrapper.dataset.date.toLocaleString("nl-NL", { timeZone: "Europe/Amsterdam" })).getTime();
    if (countDownDate - new Date().getTime() <= 0) {
      form.remove();
      formHeading.remove();
      const textElement = document.getElementById("countdown-text");
      textElement.innerHTML = textElement.dataset.finishedTranslation;
      return;
    }
    const dayElement = document.getElementById("days");
    const hoursElement = document.getElementById("hours");
    const minsElement = document.getElementById("mins");
    const secsElement = document.getElementById("secs");

    const countdownTimerInterval = setInterval(function () {
      var timeleft = countDownDate - new Date().getTime();
      if (timeleft < 0) {
        clearInterval(countdownTimerInterval);
        form.remove();
        formHeading.remove();
        const textElement = document.getElementById("countdown-text");
        textElement.innerHTML = textElement.dataset.finishedTranslation;
        return;
      }
      dayElement.innerHTML = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      hoursElement.innerHTML = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      minsElement.innerHTML = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      secsElement.innerHTML = Math.floor((timeleft % (1000 * 60)) / 1000);
    }, 1000);
  }
});
